import { render, staticRenderFns } from "./TicketDetail.vue?vue&type=template&id=8c9ca61a&scoped=true&"
import script from "./TicketDetail.vue?vue&type=script&lang=js&"
export * from "./TicketDetail.vue?vue&type=script&lang=js&"
import style0 from "./TicketDetail.vue?vue&type=style&index=0&id=8c9ca61a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9ca61a",
  null
  
)

export default component.exports